module.exports = __webpack_public_path__ + "img/mb-advantage-1.53537c49.png";